import { render } from "./ProfitableProductsCard.vue?vue&type=template&id=80f8e10e&scoped=true"
import script from "./ProfitableProductsCard.vue?vue&type=script&lang=js"
export * from "./ProfitableProductsCard.vue?vue&type=script&lang=js"

import "./ProfitableProductsCard.vue?vue&type=style&index=0&id=80f8e10e&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f8e10e"]])

export default __exports__